/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-01-13 15:41:06
 */

import MenuConfig from "../menuConfig";
import {Toast} from "src/util/toast";
import {default as CellOperate} from "src/components/agGridComponent/cellOperate";
import {IconBtnItem} from "src/components/iconBtnGroup/iconBtnGroup";
import {ColDefCustom, default as AgGridVueCustomTsx} from "src/components/agGridCustom/agGridVueCustomTsx";
import MenuConfigApi,{MenuConfigDOI} from "../api/menuConfigApi";
import _ from 'lodash'
import ListPageService from 'src/types/ListPage';
import override from "src/dectorators/override";
import {QueryFormVOI} from "src/components/queryForm/queryForm";
import EnumAuthorityType from 'src/enums/enumAuthorityType';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import alertOperateMenuModal from '../operateMenuModal';
import EnumOperates from 'src/enums/enumOperates';

export default class MenuConfigService extends ListPageService {
	ctx: MenuConfig;

	constructor (ctx: MenuConfig) {
	    super()
		this.ctx = ctx
	}

    @override
	createColumns (): ColDefCustom [] {
		let t = this
		return [
			{
				headerName: '名称',
				field: 'power_name',
				minWidth: 100
			},
			{
				headerName: 'url',
				field: 'power_url',
				minWidth: 300
			},
			{
				headerName: '类型',
				field: 'type',
                minWidth: 100,
                cellRenderer(params){
                    let data: MenuConfigDOI.RowDataI = params.data
                    return EnumAuthorityType.findId(data.type).getName()
                }
			},
			{
				headerName: '操作',
				field: 'operate',
				minWidth: 120,
				maxWidth: 120,
				cellRendererFramework: CellOperate,
				cellRendererFrameworkOpt: [
					{
						text: '删除',
						async click (params) {
							let res = await Toast.confirm()
							if (!res) {
								return
							}
							let data: MenuConfigDOI.RowDataI = params.data
							await t.delete(data.id)
						}
					}
				]
			},
		]
	}
    @override
    createBtnGroup(): Array<IconBtnItem> {
        let t = this;
        return [
            {
                text: '新增',
                async onClick() {
                    let res = await alertOperateMenuModal(EnumOperates.Add.getName());
                    if (res) {
                        t.searchTable();
                    }
                },
            }
        ];
    }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            
            {
                component: CommonSelect,
                label: '权限类型：',
                field: 'type',
                props: { value: null, dataSource: EnumAuthorityType.getList() },
            },
        ];
    }

	async delete(id: number) {
		let {code} = await MenuConfigApi.delete(id)
		if (code=== 0) {
			Toast.success('删除成功')
			this.searchTable()
		}
	}

	@override
	initSearchParams (): void {
		this.ctx.searchParams = this.ctx.queryForm.getQueryObj<MenuConfigDOI.QueryRowDataParamsI>()
		this.ctx.currentPage = 1
	}

    @override
	async searchTable () {
		let ctx = this.ctx
		let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
		ag.showLoading()
		let {code, data} = await MenuConfigApi.searchList({
			...ctx.searchParams,
			page_size: ctx.pageSize,
			page_index: ctx.currentPage
		})
		ag.hideLoading()

		if (code === 0) {
			ctx.rowData = data.data_info || []
			ctx.total = data.page_count
		}
	}

}